import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { css } from '@linaria/core'
import { Link } from '@fs/zion-router'
import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import { colors } from '@fs/zion-ui'
import churchLinks from '../components/ChurchLinks'
import CookiePreferences from '../components/CookiePreferences'
import { buildUrl } from '../footerHelperFunctions'
import AccessibilityLink from '../components/AccessibilityLink'

const legalCss = css`
  color: ${colors.transparent.gray60};
  font-size: 12px;
`

export default function MinLegalText({
  menaReligiousMode,
  nonReligiousMode,
  showArabicExperience,
  external,
  ...props
}) {
  const [t] = useTranslation()
  const year = new Date().getFullYear()

  const countryAndLangOptionsOn = useFeatureFlag('home_localePage').isOn
  const churchLink = churchLinks[i18n.language] ? churchLinks[i18n.language] : churchLinks.en
  const ReligiousModeLink = (
    <Trans i18nKey="footer.service-by-church.link">
      A service provided by
      <Link isGray wayfinding to={churchLink} linkName="footer_service_provided_by_church" external>
        The Church of Jesus Christ of Latter-day Saints
      </Link>
    </Trans>
  )
  const serviceLink = nonReligiousMode
    ? t('footer.service-by-church.text', 'A service provided by The Church of Jesus Christ of Latter-day Saints')
    : ReligiousModeLink
  return (
    <div className={legalCss} {...props}>
      <AccessibilityLink external={external} />
      <div>
        <Trans i18nKey="footer.terms-of-use">
          <Link isGray external wayfinding to={buildUrl('/legal/terms', external)} linkName="footer_terms">
            FamilySearch Terms of Use
          </Link>
        </Trans>
        &nbsp;|&nbsp;
        <Trans i18nKey="footer.privacy-notice">
          <Link isGray external wayfinding to={buildUrl('/legal/privacy', external)} linkName="footer_privacy">
            Privacy Notice
          </Link>
        </Trans>
        {countryAndLangOptionsOn && (
          <>
            &nbsp;|&nbsp;
            <Trans i18nKey="footer.country-and-language-options">
              <Link
                isGray
                wayfinding
                external
                to={buildUrl('/locale', external)}
                linkName="footer_country_and_lang_options"
              >
                Country and Language Options
              </Link>
            </Trans>
          </>
        )}
        &nbsp;|&nbsp;
        <CookiePreferences includeButton updatedButton />
      </div>
      <div>
        {t('footer.copyright-notice', '© {year} by Intellectual Reserve, Inc. All rights reserved.', { year })}{' '}
        {!(menaReligiousMode || showArabicExperience) ? serviceLink : null}
      </div>
    </div>
  )
}
